import React from 'react';

import {
  makeVar,
  useReactiveVar
} from '@apollo/client';

import { authService } from 'iron-forge-react-modules';



const authStateVar = makeVar<authService.IAuthState>({
  accessToken: '',
  authProviderUserId: '',
  status: 'noAttemptMade'
});



authService
  .getAuthStateObservable()
  .subscribe(newAuthState => {
    authStateVar(newAuthState);
  });



setInterval(async () => {
  await authService.getAuthState();
}, 1000 * 60);



export const logIn = async ({
  email, password
}: {
  email: string;
  password: string;
}) => {
  try {
    await authService.logIn({
      email,
      password
    });

  } catch (err) {
    window.alert(err);
  }
};



export const logOut = async () => {
  await authService.logOut();
};



export function useAuthState({
  onLogOut
}: {
  onLogOut?: () => void;
} = {}) {
  const [oldState, setOldState] = React.useState<authService.IAuthState['status']>('noAttemptMade');
  const authState = useReactiveVar(authStateVar);



  React.useEffect(
    () => {
      if (oldState === 'loggedIn' && authState.status === 'notLoggedIn' && onLogOut) {
        onLogOut();
      }
      if (oldState !== authState.status) {
        setOldState(() => authState.status);
      }
    },
    [authState.status, oldState, onLogOut]
  );



  return authState;
}
